import { render, staticRenderFns } from "./VEmployerVisaCasesBrowse.vue?vue&type=template&id=160a3508&scoped=true&lang=pug"
import script from "./VEmployerVisaCasesBrowse.vue?vue&type=script&lang=ts"
export * from "./VEmployerVisaCasesBrowse.vue?vue&type=script&lang=ts"
import style0 from "./VEmployerVisaCasesBrowse.vue?vue&type=style&index=0&id=160a3508&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160a3508",
  null
  
)

export default component.exports